import { Dropdown, Button } from "antd";
import BluePlusIcon from "../../../shared/assets/images/bluePlus.svg";
import { MenuProps } from "antd";

const AddSectionDropdown = ({ onSelect, disabled, text, items }: { onSelect: MenuProps['onClick'], disabled?: boolean, text: string, items: MenuProps['items'] }) => {
  return (
    <div className="mx-auto mt-8 sm:w-full">
      <Dropdown
        menu={{ items, onClick: onSelect }}
        trigger={["click"]}
        className="mb-6"
        placement="topRight"
        overlayClassName="[&_.ant-dropdown-menu]:!p-2 [&_.ant-dropdown-menu-item]:!px-4 [&_.ant-dropdown-menu-item]:!py-3 [&_.ant-dropdown-menu-item]:!m-0 [&_.ant-dropdown-menu-item]:!rounded-md [&_.ant-dropdown-menu-item]:!font-normal [&_.ant-dropdown-menu-item>span]:!text-gray-700 [&_.ant-dropdown-menu-item:hover]:!bg-[#EEF2FF] [&_.ant-dropdown-menu-item:hover>span]:!text-gray-900 [&_.ant-dropdown-menu-item:hover>*]:!text-gray-900"
        dropdownRender={(menu) => (
          <div className="overflow-y-auto absolute -top-2 left-0 sm:top-3 sm:left-32 bg-white border border-gray-300 rounded-xl shadow-md max-h-52 w-[300px] sw:w-fit-content">
            {menu}
          </div>
        )}
        disabled={disabled}
      >
        <Button
          className="border-dashed relative w-full cursor-pointer whitespace-nowrap text-indigo-700 flex !bg-transparent py-7 pl-6 items-center shadow-none text-xs !font-medium disabled:!text-indigo-300"
        >
          {text} 
          <img src={BluePlusIcon} className={`inline ms-2 ${disabled ? 'opacity-50' : ''}`} alt="+" />
        </Button>
      </Dropdown>
    </div>
  );
};


export default AddSectionDropdown;